import { createTheme, PaletteColorOptions } from '@mui/material/styles';
import { tokens } from './tokens';

// TypeScript augmentation
declare module '@mui/material/styles' {
  interface PaletteColor {
    50?: string;
    100?: string;
  }
  interface SimplePaletteColorOptions {
    50?: string;
    100?: string;
  }
  interface Palette {
    accent: Palette['primary'];
    tokens: typeof tokens;
  }
  interface PaletteOptions {
    accent?: PaletteColorOptions;
    tokens?: typeof tokens;
  }
}

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: tokens.primary[500],
      light: tokens.primary[300],
      dark: tokens.primary[700],
      contrastText: '#FFFFFF',
      50: tokens.primary[50],
      100: tokens.primary[100],
    },
    secondary: {
      main: tokens.secondary[500],
      contrastText: '#FFFFFF',
    },
    accent: {
      main: tokens.accent[500],
      light: tokens.accent[200],
      dark: tokens.accent[600],
      contrastText: tokens.secondary[500],
    },
    success: {
      main: tokens.semantic.success,
      contrastText: '#FFFFFF',
      50: tokens.semantic.success50,
      100: tokens.semantic.success100,
    },
    error: {
      main: tokens.semantic.error,
      contrastText: '#FFFFFF',
    },
    warning: {
      main: tokens.semantic.warning,
      contrastText: tokens.neutrals[500],
      50: tokens.semantic.warning50,
      100: tokens.semantic.warning100,
    },
    info: {
      main: tokens.semantic.info,
      contrastText: '#FFFFFF',
      50: tokens.semantic.info50,
      100: tokens.semantic.info100,
    },
    grey: {
      50: tokens.neutrals[50],
      100: tokens.neutrals[100],
      200: tokens.neutrals[200],
      300: tokens.neutrals[300],
      400: tokens.neutrals[400],
      500: tokens.neutrals[500],
    },
    tokens,
    background: {
      default: tokens.neutrals[0],
      paper: tokens.neutrals[0],
    },
    text: {
      primary: tokens.neutrals[500],
      secondary: tokens.neutrals[400],
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Inter", Roboto, system-ui, sans-serif',
    h1: { fontWeight: 600, fontSize: '3rem', lineHeight: 1.125 },
    h2: { fontWeight: 600, fontSize: '2.25rem', lineHeight: 1.2 },
    h3: { fontWeight: 600, fontSize: '1.75rem', lineHeight: 1.3 },
    body1: { fontSize: '1rem', lineHeight: 1.5 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundColor: tokens.neutrals[0],
          color: tokens.neutrals[500],
        },
        '*, *::before, *::after': {
          boxSizing: 'border-box',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});

export default theme;
